import { SVGProps } from 'react';

const EmailVerificationIcon = ({
  height = '115px',
  width = '115px',
  isError = false,
  ...props
}: SVGProps<SVGSVGElement> & { isError?: boolean }): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 115 115'
    {...props}
  >
    <g transform='translate(-162 -247)'>
      <circle
        cx='57.5'
        cy='57.5'
        r='57.5'
        transform='translate(162 247)'
        fill={isError ? '#FCE6DB' : '#dff8d4'}
      />
      <circle
        cx='45'
        cy='45'
        r='45'
        transform='translate(175 260)'
        fill={isError ? '#E07F62' : '#60b96b'}
        opacity='0.23'
      />
      <path
        d='M1.5,31.5h6v-18h-6ZM34.5,15a3.009,3.009,0,0,0-3-3H22.035L23.46,5.145l.045-.48a2.258,2.258,0,0,0-.66-1.59L21.255,1.5l-9.87,9.885A2.933,2.933,0,0,0,10.5,13.5v15a3.009,3.009,0,0,0,3,3H27a2.98,2.98,0,0,0,2.76-1.83L34.29,19.1A2.964,2.964,0,0,0,34.5,18V15.135l-.015-.015Z'
        transform={
          isError
            ? 'translate(235.5 326.5) rotate(180)'
            : 'translate(201.5 287.5)'
        }
        fill={isError ? '#E07F62' : '#60b96b'}
      />
    </g>
  </svg>
);

export default EmailVerificationIcon;
